import * as React from "react";
import { useTranslation } from "react-i18next";
import "./movieItemViewStyles.css";
export var MovieTagView = function (_a) {
    var movie = _a.movie;
    var t = useTranslation().t;
    var isComingSoon = movie.status === "CS" ||
        (movie.episodes && movie.episodes[0].status === "CS");
    var isEST = movie.type === "EST" && !movie.bought;
    return isComingSoon ? (React.createElement("p", { className: "tag" }, t("movie.coming_soon"))) : isEST ? (React.createElement("p", { className: "tag" }, t("card.movie.buy"))) : null;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/MovieTagView.tsx
// module id = 115
// module chunks = 1